export { IndividualTile, type IndividualTileProps } from './IndividualTile';
